import React from 'react';
import { Button } from '@mui/material'

import * as _ from 'lodash'
import IosCalendar from 'react-ionicons/lib/IosCalendar'
import { copyObject } from '../../utils';

import IosAdd from 'react-ionicons/lib/IosAdd'
import { ClientExtendsT } from './Booking';
import config from '../../constants/config';

import moment from 'moment'
import { extractStartTime, getJobMoveDate } from '../jobs/NewJob/JobUtils';
import { JobStatusT, JobT } from '../../types/Job';
import { AxiosInstance } from '../../utils/RequestMethods'
import { AuthStateT } from '../../redux/reducers/authReducer';
import { useSelector } from 'react-redux';
import { IAppState } from '../../redux/reducers';
const styles = {
    left: {
        marginLeft: 0
    },
    required: {
        color: 'red'
    }
}

export type IScreenClientHomeProps = {
    client: ClientExtendsT
    tokenUser: string
    bookJob(job: JobT): void
    bookedJob(job: JobT): void
    newMovingInquiry(): void
}

const ScreenClientHome: React.FC<IScreenClientHomeProps> = (props) => {
    const [jobs, setJobs] = React.useState<Array<JobT>>([]);
    const [inquiringJobs, setInquiringJobs] = React.useState([]);
    const [scheduledJobs, setScheduledJobs] = React.useState([]);
    const [isReady, setIsReady] = React.useState(false);
    const clientFirstName = 'Khalid'
    const companyName = 'Raptor Moving'
    let auth: AuthStateT = useSelector((state: IAppState) => state.auth)
    // const inquiringJobs: Array<JobT> = [{ ...copyObject(JobObj), date: 'Sep 4, 2021' }]
    // const scheduledJobs: Array<JobT> = [{ ...copyObject(JobObj), date: 'Sep 12, 2021' }]


    React.useEffect(() => {
        getJobs()
    }, [])



    const getJobs = async (): Promise<any> => {

        let params = {
            page: 1,
            per_page: 50,
            jobStatus: [JobStatusT.inquiring, JobStatusT.scheduled]
        }
        let options = {
            data: params,
            // headers: {
            //     'Authorization': `Bearer ${props.tokenUser}`
            // }
        }

        AxiosInstance.get(`${config.url.wpJson}/wp/v2/jobs`, options).then((res) => {
            if (res && res.data) {
                const resultJobs: Array<JobT> = res.data
                setInquiringJobs(resultJobs.filter((job) => job.jobStatus == "inquiring"))
                setScheduledJobs(resultJobs.filter((job) => job.jobStatus == "scheduled"))
                setJobs(resultJobs)
            }
            setIsReady(true)
        }).catch((error) => {
            setIsReady(true)
        })
    }

    /**
     *
     * @param job
     * @returns
     */
    // const extractStartTime = (job: JobT): string | null => {
    //     if (_.isArray(job.locations) && job.locations.length > 0 && _.isArray(job.locations[0].activities) && job.locations[0].activities.length > 0) {

    //         return moment(job.locations[0].activities[0].startTime).isValid() ? moment(job.locations[0].activities[0].startTime).toDate().toString() : null
    //     }
    //     else return null
    // }

    const formatStartTime = (date: string, format: string = "[at] h:mm A"): string | null => {
        return date && date != "" ? moment(date).format(format) : ""
    }



    const getScheduledDate = (job: JobT) => {
        let jobTime = extractStartTime(job)
        let format = "MMM D, YYYY [at] h:mm A"
        if (!jobTime) {
            format = "MMM D, YYYY"
        }
        let moveDate = getJobMoveDate(job, format, true)
        return moveDate
    }

    return (
        <div>
            <p>Welcome back, {auth?.userData?.firstName}!</p>
            <hr />
            <div>
                <p><strong>Moving Inquiries</strong></p>
                {inquiringJobs.length == 0 && <div>
                    <p style={{ fontStyle: 'italic' }}>You do not have any open inquiries.</p>
                </div>}
                {inquiringJobs.length > 0 && inquiringJobs.map((job: JobT): JSX.Element => {
                    return (
                        <div className="mt-1" style={{ display: 'flex', flexDirection: 'row',gap:3 }}>
                            <div className="d-flex align-items-center " style={{  }}>
                                <Button variant="contained" color="primary" fullWidth  style={{ marginLeft: 0 }} onClick={() => props.bookJob(job)}><IosCalendar color="white" />&nbsp;Book Now</Button>
                            </div>
                            <div className="d-flex align-items-center" style={{ flex: 2 }}>
                                {/* Date: {moment.utc(iJob.date).local().format('MMM D, YYYY') } */}
                                {/* Date: {moment(job.scheduledDate).format('MMM D, YYYY')} {formatStartTime(extractStartTime(job))} */}
                                Date: {getScheduledDate(job)}

                            </div>
                        </div>
                    )
                })}
                {scheduledJobs.length > 0 && <div>
                    <p><strong>Booked Jobs</strong></p>
                    <ul>
                        {scheduledJobs.map((job: JobT): JSX.Element => {
                            return (
                                <li>
                                    {/* Date: {moment.utc(sJob.date).local().format('MMM D, YYYY') } */}
                                    {/* Date: {moment(job.scheduledDate).format('MMM D, YYYY')} {formatStartTime(extractStartTime(job))} */}
                                    Date: {getScheduledDate(job)}
                                </li>
                            )
                        })}
                    </ul>
                </div>}
            </div>
            <Button
               className='mt-2'
                style={styles.left}
                onClick={() => {
                    props.newMovingInquiry()
                }}
                color="success"
                variant="contained">
                <IosAdd color="white" />
                &nbsp;
                New Moving Inquiry
            </Button>
        </div>
    );
}
export default ScreenClientHome
